import { useLocation, useNavigate, useParams } from "react-router";
import { useCartContext } from "../context/cartContext";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { SERVER_URL } from "../config";



export default function SuccessPage() {
  const { company: companyParam } = useParams();
  const { clearCart } = useCartContext();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const setmenuUuid = searchParams.get("user_campaign_setmenu_uuid");
  const normalizedServerUrl = SERVER_URL.replace(/\/$/, "");
  const qrCodeImageUrl = setmenuUuid
    ? `${normalizedServerUrl}/user-transaction/campaign/qrcode.png?data=${encodeURIComponent(
        setmenuUuid
      )}`
    : "";

  // Clear cart on success page
  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <main>
      <div style={{ textAlign: "center", marginTop: 40 }}>
        <img src="/assets/success.svg" alt="Success" style={{ width: 120, height: 120, marginBottom: 24 }} />
        <h2 style={{ fontSize: 24, marginBottom: 16 }}>謝謝你的訂單！</h2>
        <p style={{ fontSize: 16, color: "#555" }}>訂單已確認，二維碼已發送至您的電子郵箱。</p>
        {qrCodeImageUrl ? (
          <div style={{ marginTop: 24 }}>
            <img
              src={qrCodeImageUrl}
              alt="Order QR Code"
              style={{ width: 260, height: 260, backgroundColor: "#fff", padding: 8, borderRadius: 8 }}
            />
            <p style={{ fontSize: 14, color: "#555", marginTop: 12 }}>或請妥善保存此二維碼(可擷圖)</p>
            <p  style={{ fontSize: 14, color: "#555", marginTop: 8 }}>並於兌換時出示于職員掃瞄</p>
          </div>
        ) : null}
        <Button onClick={() => navigate(`/${companyParam}`)} style={{ display: "inline-block", marginTop: 24, padding: "12px 24px", backgroundColor: "var(--bs-primary)", color: "white", borderRadius: 50, textDecoration: "none" }}>
          返回主頁
        </Button>
      </div>
    </main>
  );
}